export default __webpack_public_path__ + "static/media/Sabel & Tiny.c827bf78.png";